import { hasItem } from '@sravni/ugc/lib/specialOffers/helpers';
import { ACTIONS_LIST } from '@sravni/ugc/lib/specialOffers/lists';

const generateHeadingTitle = (tabType) => {
    if (hasItem(ACTIONS_LIST, tabType)) {
        return `Ваши действия`;
    }
    return `Интересные предложения`;
};

export { generateHeadingTitle };
//# sourceMappingURL=generateHeadingTitle.js.map
